var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ active: _vm.showScrollButton },attrs:{"id":"scrollTop","aria-label":_vm.$t('scrollToTop')},on:{"click":_vm.onScroll}})}
var staticRenderFns = []

export { render, staticRenderFns }